import React, { useEffect, useState } from 'react';
import {
  KTSVG,
  SimpleAlert,
  toAbsoluteUrl,
} from '../../../../../_mexablock/helpers';
import Select from 'react-select';
import { NumericFormat } from 'react-number-format';
import { Modal } from 'react-bootstrap-v5';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { addCallCenter } from '../../../../service/callcenter/CallCenter';
import {
  getInventaryById,
  getSelectTypeProvider,
  getSelectTypeStock,
  updProduct,
} from '../../../../service/inventario/productos';
import { getProtectedImageUrl } from '../../../../service/inventario/productos';

type Props = {
  show: boolean;
  handleClose: (updateGrid: boolean) => void;
  idPackage: number;
};

const defaultValues = {
  id: 0,
  description: '',
  provider_id: 0,
  type_stock_id: 0,
  input_price: '',
  output_price: '',
  location: '',
  total_price_output: '',
  image: '',
  created_by: 0,
  createdAt: '',
  updatedAt: '',
  total_stock: '',
  available: '',
};

const ProductSchema = Yup.object().shape({
  type_stock_id: Yup.mixed().required('Selecciona tipo'),
  provider_id: Yup.mixed().required('Selecciona proveedor'),
  description: Yup.string()
    .required('La descripción es requerida')
    .max(150, 'Máximo 150 caracteres.'),
  input_price: Yup.number()
    .required('El precio de compra es requerido')
    .min(1, 'El precio de compra debe ser al menos $1.00.')
    .max(1000, 'El precio de compra no puede exceder $1,000.00.'),
  output_price: Yup.number()
    .required('El precio de venta es requerido')
    .min(1, 'El precio de venta debe ser al menos $1.00.')
    .max(1000, 'El precio de venta no puede exceder $1,000.00.'),
});

const UpdateModal: React.FC<Props> = ({ show, handleClose, idPackage }) => {
  const [loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState<string | null | undefined>();
  const [selectStock, setSelectStock] = useState();
  const [selectedOptionSupplier, setSelectedOptionSupplier] = useState(null);
  const [selectedOptionStock, setSelectedOptionStock] = useState(null);
  const [selectProvider, setSelectProvider] = useState();
  const [initValues, setInitValues] = useState(defaultValues);

  const productForm = useFormik({
    initialValues: initValues,
    validationSchema: ProductSchema,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting, setFieldError }) => {
      setLoading(true);
      setTimeout(() => {
        updProduct(values)
          .then((res) => {
            const {
              data: { message },
            } = res;
            SimpleAlert(message, 3000, 'success');
            productForm.resetForm();
            setPreviewImage('');
            setLoading(false);
            handleClose(true);
          })
          .catch((err) => {
            let resMessageToast: string = '';
            const {
              data: { message, details = null },
            } = err.response;
            resMessageToast = `${message}`;
            if (details.length) {
              resMessageToast = `${details[0].message}`;
            }
            setLoading(false);
            setSubmitting(false);
            SimpleAlert(resMessageToast, 3000, 'error');
          });
      }, 1000);
    },
  });

  const fetchPost = async () => {
    setPreviewImage('');
    try {
      const packageInit = await getInventaryById(idPackage);
      const proveedores = await getSelectTypeProvider();
      const stock = await getSelectTypeStock();

      if (packageInit) {
        setInitValues({ ...defaultValues, ...packageInit });

        const imageInit = await getProtectedImageUrl(packageInit.image);
        if (imageInit) setPreviewImage(imageInit);

        if (stock) {
          setSelectStock(stock);
          const selectedStock = stock.find(
            (s: any) => s.value === packageInit.type_stock_id
          );
          setSelectedOptionStock(selectedStock || null);
        }

        if (proveedores) {
          setSelectProvider(proveedores);
          const selectedProvider = proveedores.find(
            (p: any) => p.value === packageInit.provider_id
          );
          setSelectedOptionSupplier(selectedProvider || null);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleTypeSupplier = (selectedOption: any) => {
    const id = selectedOption.value;
    setSelectedOptionSupplier(selectedOption);
    productForm.setFieldValue('provider_id', id);
  };

  const handleTypeStock = (selectedOption: any) => {
    const id = selectedOption.value;
    setSelectedOptionStock(selectedOption);

    productForm.setFieldValue('type_stock_id', id);
  };

  const onPurchasePriceChange = (values: { floatValue: any | null }): void => {
    const { floatValue } = values;
    const newBalance = floatValue ?? 0;

    productForm.setFieldValue('input_price', newBalance);
  };

  const onSalePriceChange = (values: { floatValue: any | null }): void => {
    const { floatValue } = values;
    const newBalance = floatValue ?? 0;

    productForm.setFieldValue('output_price', newBalance);
  };

  useEffect(() => {
    fetchPost();
  }, [show]);

  return (
    <Modal
      id="kt_modal_create"
      tabIndex={-1}
      aria-hidden="true"
      dialogClassName="modal-dialog modal-dialog-centered modal-xl"
      show={show}
      onHide={() => {
        productForm.resetForm();
        handleClose(true);
        setPreviewImage('');
      }}
    >
      <div className="modal-content">
        <div className="modal-header pb-0 border-0 justify-content-end">
          <div
            className="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
            onClick={() => {
              productForm.resetForm();
              handleClose(true);
              setPreviewImage('');
            }}
          >
            <KTSVG
              className="svg-icon-2"
              path="/media/icons/duotune/arrows/arr061.svg"
            />
          </div>
        </div>

        <div className="modal-body scroll-y mx-5 pt-0">
          <div className="text-center mb-13">
            <h1 className="mb-3">Editar producto</h1>
            <div className="text-muted fw-semibold fs-5">
              Modifica la información del producto.
            </div>
          </div>
          <form
            id="kt_modal_generic_form"
            className="form"
            action="#"
            onSubmit={productForm.handleSubmit}
          >
            <div className="w-100 container">
              <span className="fw-bolder fs-5">Detalles generales</span>
              <div className="separator border-2 my-10" />
              <div className="row" style={{ marginBottom: '60px' }}>
                <div className="col-3">
                  <div className="col-lg-8">
                    <div
                      className="image-input image-input-outline"
                      data-kt-image-input="true"
                    >
                      <img
                        src={
                          previewImage
                            ? previewImage
                            : toAbsoluteUrl('/media/avatars/Vector.png')
                        }
                        className="image-input-wrapper w-200px h-200px bg-secondary"
                        crossOrigin="anonymous"
                        alt="paquete"
                      />
                      <label
                        className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                        data-kt-image-input-action="change"
                        data-bs-toggle="tooltip"
                        title="Change avatar"
                      >
                        <i className="bi bi-pencil-fill fs-7"></i>
                        <input
                          type="file"
                          name="image"
                          accept=".png, .jpg, .jpeg"
                          onChange={(event) => {
                            if (event.currentTarget.files) {
                              let file = event.currentTarget.files[0];
                              const MAX_FILE_SIZE_MB = 5;
                              const MAX_FILE_SIZE_BYTES =
                                MAX_FILE_SIZE_MB * 1024 * 1024;
                              if (file.size > MAX_FILE_SIZE_BYTES) {
                                SimpleAlert(
                                  'El peso de la imagen del producto debe ser de un máximo de 5MB',
                                  3000,
                                  'error'
                                );
                                return;
                              }
                              let reader = new FileReader();
                              reader.onload = () => {
                                const csv: string = reader.result as string;
                                setPreviewImage(csv);
                              };
                              reader.readAsDataURL(file);
                              productForm.setFieldValue('image', file);
                            }
                          }}
                        />
                      </label>
                      <span
                        className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                        data-kt-image-input-action="cancel"
                        data-bs-toggle="tooltip"
                        title="Cancel avatar"
                      >
                        <i className="bi bi-x fs-2"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-9">
                  <div className="row">
                    <div className="col mb-7">
                      <div className="w-100 d-flex">
                        <label className="fw-bold fs-6 mb-2 required">
                          Tipo
                        </label>
                      </div>
                      <div onClick={(e) => e.stopPropagation()}>
                        <Select
                          options={selectStock}
                          placeholder={'Seleccione'}
                          onChange={handleTypeStock}
                          value={selectedOptionStock}
                          isDisabled
                          noOptionsMessage={() => {
                            return <span>No hay registros</span>;
                          }}
                          styles={{
                            indicatorSeparator: (provided, state) => ({
                              ...provided,
                              display: 'none',
                            }),

                            control: (provided, state) => ({
                              ...provided,
                              border: '1px solid #e4e6ef',
                              borderRadius: '6px',
                              padding: '3px',
                              fontSize: '1.1rem',
                              boxShadow: 'none',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              fontSize: '1.1rem',
                            }),
                          }}
                        />
                        {productForm.touched.type_stock_id &&
                          productForm.errors.type_stock_id && (
                            <div className="fv-plugins-message-container text-danger  ms-5">
                              <span role="alert">
                                {productForm.errors.type_stock_id}
                              </span>
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="col mb-7">
                      <div className="w-100 d-flex">
                        <label className="fw-bold fs-6 mb-2 required">
                          Proveedor
                        </label>
                      </div>
                      <div onClick={(e) => e.stopPropagation()}>
                        <Select
                          options={selectProvider}
                          placeholder={'Seleccione'}
                          onChange={handleTypeSupplier}
                          value={selectedOptionSupplier}
                          noOptionsMessage={() => {
                            return <span>No hay registros</span>;
                          }}
                          styles={{
                            indicatorSeparator: (provided, state) => ({
                              ...provided,
                              display: 'none',
                            }),

                            control: (provided, state) => ({
                              ...provided,
                              border: '1px solid #e4e6ef',
                              borderRadius: '6px',
                              padding: '3px',
                              fontSize: '1.1rem',
                              boxShadow: 'none',
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              fontSize: '1.1rem',
                            }),
                          }}
                        />
                        {productForm.touched.provider_id &&
                          productForm.errors.provider_id && (
                            <div className="fv-plugins-message-container text-danger  ms-5">
                              <span role="alert">
                                {productForm.errors.provider_id}
                              </span>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="w-100 d-flex">
                    <label className="fw-bold fs-6 mb-2 required">
                      Descripción
                    </label>
                  </div>
                  <textarea
                    placeholder="Descripción"
                    className="form-control mb-3 mb-lg-0"
                    value={productForm.values.description || ''}
                    onChange={(e) =>
                      productForm.setFieldValue('description', e.target.value)
                    }
                  />
                  {productForm.touched.description &&
                    productForm.errors.description && (
                      <div className="fv-plugins-message-container text-danger  ms-5">
                        <span role="alert">
                          {productForm.errors.description}
                        </span>
                      </div>
                    )}
                </div>
              </div>
              <span className="fw-bolder fs-5">Precios</span>
              <div className="separator border-2 my-10" />

              <div className="row">
                <div className="col-6"></div>
                <div className="col-6">
                  <div className="row">
                    <div className="col mb-7">
                      <div className="w-100 d-flex">
                        <label className="fw-bold fs-6 mb-2 required">
                          Precio de compra
                        </label>
                      </div>
                      <NumericFormat
                        name="purchasePrice"
                        type="text"
                        autoComplete="off"
                        disabled
                        className="form-control mb-3 w-100"
                        value={productForm.values.input_price}
                        decimalScale={2}
                        decimalSeparator="."
                        fixedDecimalScale
                        placeholder="$ 0.00"
                        prefix="$ "
                        allowNegative={false}
                        thousandSeparator=","
                        onValueChange={(values) =>
                          onPurchasePriceChange(values)
                        }
                      />
                      {productForm.touched.input_price &&
                        productForm.errors.input_price && (
                          <div className="fv-plugins-message-container text-danger  ms-5">
                            <span role="alert">
                              {productForm.errors.input_price}
                            </span>
                          </div>
                        )}
                    </div>
                    <div className="col mb-7">
                      <div className="w-100 d-flex">
                        <label className="fw-bold fs-6 mb-2 required">
                          Precio de venta
                        </label>
                      </div>

                      <NumericFormat
                        name="salePrice"
                        type="text"
                        autoComplete="off"
                        disabled
                        className="form-control mb-3 w-100"
                        value={productForm.values.output_price}
                        decimalScale={2}
                        decimalSeparator="."
                        fixedDecimalScale
                        placeholder="$ 0.00"
                        prefix="$ "
                        allowNegative={false}
                        thousandSeparator=","
                        onValueChange={(values) => onSalePriceChange(values)}
                      />
                      {productForm.touched.output_price &&
                        productForm.errors.output_price && (
                          <div className="fv-plugins-message-container text-danger  ms-5">
                            <span role="alert">
                              {productForm.errors.output_price}
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center pt-10">
              <button
                type="reset"
                className="btn btn-light me-3"
                data-kt-users-modal-action="cancel"
                onClick={() => {
                  productForm.resetForm();
                  handleClose(false);
                  setPreviewImage('');
                }}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                data-kt-users-modal-action="submit"
                disabled={loading}
              >
                {!loading && <span className="indicator-label">Guardar</span>}
                {loading && (
                  <span
                    className="indicator-progress"
                    style={{ display: 'block' }}
                  >
                    Espere por favor...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};
export { UpdateModal };
